import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M9.75 5.25a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75ZM9 18a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H9.75A.75.75 0 0 1 9 18ZM6.223 5.876a.3.3 0 0 1-.3.3h-.12a.3.3 0 0 0-.3.3v3.448a.3.3 0 0 0 .3.3h.12a.3.3 0 0 1 .3.3v.176a.3.3 0 0 1-.3.3H4.075a.3.3 0 0 1-.3-.3v-.176a.3.3 0 0 1 .3-.3h.12a.3.3 0 0 0 .3-.3V6.476a.3.3 0 0 0-.3-.3h-.12a.3.3 0 0 1-.3-.3V5.7a.3.3 0 0 1 .3-.3h1.848a.3.3 0 0 1 .3.3v.176Zm-1.778 8a.3.3 0 0 1-.3.3h-.12a.3.3 0 0 0-.3.3v3.448a.3.3 0 0 0 .3.3h.12a.3.3 0 0 1 .3.3v.176a.3.3 0 0 1-.3.3H2.297a.3.3 0 0 1-.3-.3v-.176a.3.3 0 0 1 .3-.3h.12a.3.3 0 0 0 .3-.3v-3.448a.3.3 0 0 0-.3-.3h-.12a.3.3 0 0 1-.3-.3V13.7a.3.3 0 0 1 .3-.3h1.848a.3.3 0 0 1 .3.3v.176Zm3.255.3a.3.3 0 0 0 .3-.3V13.7a.3.3 0 0 0-.3-.3H5.852a.3.3 0 0 0-.3.3v.176a.3.3 0 0 0 .3.3h.12a.3.3 0 0 1 .3.3v3.448a.3.3 0 0 1-.3.3h-.12a.3.3 0 0 0-.3.3v.176a.3.3 0 0 0 .3.3H7.7a.3.3 0 0 0 .3-.3v-.176a.3.3 0 0 0-.3-.3h-.12a.3.3 0 0 1-.3-.3v-3.448a.3.3 0 0 1 .3-.3h.12Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextListUppercaseRomanIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textListUppercaseRoman')) as IconWithRender;

TextListUppercaseRomanIcon.displayName = 'TextListUppercaseRomanIcon';
TextListUppercaseRomanIcon.propTypes = Icon.propTypes;
TextListUppercaseRomanIcon.renderIcon = (props) => (
  <TextListUppercaseRomanIcon {...props} />
);
export default TextListUppercaseRomanIcon;
